import { AdminEnvironment } from './environment.type';

export const environment: AdminEnvironment = {
  production: true,
  apiUrl: 'https://admin-api-uat.crewjam.tw',
  imagesUrl: 'https://images-uat.crewjam.tw',
  frontendUrl: 'https://web-dance-topic.bodcompanyrf.workers.dev',
};
